import { combineReducers } from 'redux';

import { reducer as login } from 'auth/login';
import { reducer as registration } from 'auth/registration';
import { reducer as tfa } from 'auth/twoStepAuth';

const reducers = combineReducers({
  login,
  registration,
  tfa,
});

const reducer = (state, action) => reducers(state, action);

export default reducer;
